<template>
    <div class="field-container">        
        <div class="field full">        
            <label for="" class="label">Power Name</label>
            <div class="control">
                <input type="text" class="input" :value="name" @input="updateName">
            </div>        
        </div>
        <div class="field full">        
            <label for="" class="label">Emote</label>
            <div class="control">
                <textarea class="textarea" :value="emote" @input="updateEmote"></textarea>
            </div>      
        </div>          
        <div class="field">
            <label for="" class="label">Class</label>    
            <input type="text" class="input" :value="powerClass" @input="updateClass">
        </div>             
        <div class="field quarter">
            <label for="" class="label">Level</label>    
            <input type="text" class="input" :value="level" @input="updateLevel">
        </div>
        <div class="field quarter">
            <label for="" class="label">Power Type</label>
            <div class="select">
                <select name="" id="" :value="type" @change="updateType">
                    <option value="atwill">At-Will</option>
                    <option value="encounter">Encounter</option>
                    <option value="daily">Daily</option>
                    <option value="item">Item</option>
                    <option value="other">Other</option>
                    <option value="ability">Ability</option>
                    <option value="skill">Skill</option>                            
                </select>
            </div>                    
        </div>              
        <div class="field">
            <label for="" class="label">Power Type Name</label>    
            <input type="text" class="input" :value="typeName" @input="updateTypeName">
        </div>
        <div class="field">
            <label for="" class="label">Keywords</label>    
            <input type="text" class="input" :value="keywords" @input="updateKeywords">
        </div>        
        <div class="field">
            <label for="" class="label">Action Type</label>    
            <input type="text" class="input" :value="actionType" @input="updateActionType">
        </div>        
        <div class="field">
            <label for="" class="label">Range</label>    
            <input type="text" class="input" :value="range" @input="updateRange">
        </div> 
        <div class="field">
            <label for="" class="label">Requirement</label>    
            <input type="text" class="input" :value="requirement" @input="updateRequirement">
        </div> 
        <div class="field">
            <label for="" class="label">Trigger</label>    
            <input type="text" class="input" :value="trigger" @input="updateTrigger">
        </div>                
        <div class="field">
            <label for="" class="label">Before Special</label>    
            <textarea name="" id="" cols="30" rows="3" class="textarea" :value="beforeSpecial" @input="updateBeforeSpecial"></textarea>            
        </div> 
        <div class="field">
            <label for="" class="label">Before Effect</label>    
            <textarea name="" id="" cols="30" rows="3" class="textarea" :value="beforeEffect" @input="updateBeforeEffect"></textarea>            
        </div> 
        <div class="field full">
            <label for="" class="label">Target</label>    
            <input type="text" class="input" :value="target" @input="updateTarget">
        </div> 
        <div class="field">
            <label for="" class="label">Effect</label>                
            <textarea name="" id="" cols="30" rows="3" class="textarea" :value="effect" @input="updateEffect"></textarea>
        </div>      
        <div class="field">
            <label for="" class="label">Special</label>                
            <textarea name="" id="" cols="30" rows="3" class="textarea" :value="special" @input="updateSpecial"></textarea>
        </div>         
    </div>    
</template>

<script>
import { mapState } from 'vuex';

export default {  
    props: {
        
    },
    data: function() {
        return {

        };
    },
    computed: {
        ...mapState('basic', [
            'name',
            'emote',
            'type',
            'powerClass',
            'level',
            'typeName',
            'keywords',
            'actionType',
            'range',
            'effect',
            'beforeEffect',
            'requirement',
            'trigger',       
            'beforeSpecial',     
            'special',
            'target',
        ]),
    },
    methods: {           
        updateName(e) {
            this.$store.commit('basic/setName', e.target.value);
        },
        updateEmote(e) {
            this.$store.commit('basic/setEmote', e.target.value);
        },
        updateType(e) {
            this.$store.commit('basic/setType', e.target.value);
        },
        updateClass(e) {
            this.$store.commit('basic/setPowerClass', e.target.value);
        },
        updateLevel(e) {
            this.$store.commit('basic/setLevel', e.target.value);
        },
        updateTypeName(e){
            this.$store.commit('basic/setTypeName', e.target.value);
        },
        updateKeywords(e){
            this.$store.commit('basic/setKeywords', e.target.value);
        },
        updateActionType(e){
            this.$store.commit('basic/setActionType', e.target.value);
        },
        updateRange(e){
            this.$store.commit('basic/setRange', e.target.value);
        },
        updateEffect(e){
            this.$store.commit('basic/setEffect', e.target.value);
        },
        updateBeforeEffect(e){
            this.$store.commit('basic/setBeforeEffect', e.target.value);
        },
        updateRequirement(e){
            this.$store.commit('basic/setRequirement', e.target.value);
        },
        updateTrigger(e){
            this.$store.commit('basic/setTrigger', e.target.value);
        },
        updateBeforeSpecial(e){
            this.$store.commit('basic/setBeforeSpecial', e.target.value);
        },
        updateSpecial(e){
            this.$store.commit('basic/setSpecial', e.target.value);
        },
        updateTarget(e){
            this.$store.commit('basic/setTarget', e.target.value);
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
</style>